/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

window.Parsley.addValidator('joinCode', {
  validateString(value, requirement) {
    const regex = /^([a-zA-z0-9]{8})-([a-zA-z0-9]{4})-([a-zA-z0-9]{4})-([a-zA-z0-9]{4})-([a-zA-z0-9]{12})$/;
    return regex.test(value);
  },
  messages: {
    en: 'Unexpected join code format.',
  },
});
